import {createReducer, on} from '@ngrx/store';
import {createEntityAdapter, EntityAdapter, EntityState} from '@ngrx/entity';
import {CitizensServicesProvisionMeans} from './citizens-services-provision-means.model';
import * as CitizensServicesProvisionMeansActions from './citizens-services-provision-means.actions';

export const citizensServicesProvisionMeansesFeatureKey = 'citizensServicesProvisionMeanses';

export interface State extends EntityState<CitizensServicesProvisionMeans> {
  // additional entities state properties
}

export const adapter: EntityAdapter<CitizensServicesProvisionMeans> = createEntityAdapter<CitizensServicesProvisionMeans>();

export const initialState: State = adapter.getInitialState({
  // additional entity state properties
});

export const reducer = createReducer(
  initialState,
  on(CitizensServicesProvisionMeansActions.addCitizensServicesProvisionMeans,
    (state, action) => adapter.addOne(action.citizensServicesProvisionMeans, state)
  ),
  on(CitizensServicesProvisionMeansActions.upsertCitizensServicesProvisionMeans,
    (state, action) => adapter.upsertOne(action.citizensServicesProvisionMeans, state)
  ),
  on(CitizensServicesProvisionMeansActions.addCitizensServicesProvisionMeanss,
    (state, action) => adapter.addMany(action.citizensServicesProvisionMeanss, state)
  ),
  on(CitizensServicesProvisionMeansActions.upsertCitizensServicesProvisionMeanss,
    (state, action) => adapter.upsertMany(action.citizensServicesProvisionMeanss, state)
  ),
  on(CitizensServicesProvisionMeansActions.updateCitizensServicesProvisionMeans,
    (state, action) => adapter.updateOne(action.citizensServicesProvisionMeans, state)
  ),
  on(CitizensServicesProvisionMeansActions.updateCitizensServicesProvisionMeanss,
    (state, action) => adapter.updateMany(action.citizensServicesProvisionMeanss, state)
  ),
  on(CitizensServicesProvisionMeansActions.deleteCitizensServicesProvisionMeans,
    (state, action) => adapter.removeOne(action.id, state)
  ),
  on(CitizensServicesProvisionMeansActions.deleteCitizensServicesProvisionMeanss,
    (state, action) => adapter.removeMany(action.ids, state)
  ),
  on(CitizensServicesProvisionMeansActions.loadCitizensServicesProvisionMeanss,
    (state, action) => adapter.setAll(action.citizensServicesProvisionMeanss, state)
  ),
  on(CitizensServicesProvisionMeansActions.clearCitizensServicesProvisionMeanss,
    state => adapter.removeAll(state)
  ),
);

export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal,
} = adapter.getSelectors();
